import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React from "react";
import { RaiseColors, makeStyles } from "client/componentLibrary";
import classNames from "classnames";
import { trackEvent, TrackingEventContext, TrackingEventNames, TrackingEventPageView } from "utils/Analytics";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles({
  chevronContainer: {
    position: "absolute",
    height: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    visibility: "hidden",
    pointerEvents: "none",
    "& span": {
      pointerEvents: "auto"
    }
  },
  chevron: {
    fontSize: 12,
    "&:hover": {
      transform: "scale(1.2)",
      transition: "all 50ms ease",
      "& i:first-child": {
        opacity: 1
      }
    },
    "& i:first-child": {
      color: RaiseColors.white,
      opacity: 0.8
    },
    "& i:last-child": {
      color: RaiseColors.gray400
    }
  },
  invisible: {
    visibility: "hidden"
  },
  carouselContainer: {
    "&:hover $chevronContainer": {
      visibility: "visible"
    }
  },
  carouselContainerHideHover: {
    "&:hover $chevronContainer": {
      visibility: "hidden"
    }
  },
  imageClass: {
    objectFit: "cover",
    height: 200,
    width: "100%",
    minWidth: 258
  },
  loadingImage: {
    "& $chevronContainer": {
      display: "none"
    },
    "& img": {
      background: RaiseColors.gray200
    }
  }
});
export var Carousel = function Carousel(_ref) {
  var _ref$imageLinks = _ref.imageLinks,
    imageLinks = _ref$imageLinks === void 0 ? [] : _ref$imageLinks,
    _ref$onImageClick = _ref.onImageClick,
    onImageClick = _ref$onImageClick === void 0 ? function () {} : _ref$onImageClick,
    showImageAsLoading = _ref.showImageAsLoading,
    customImageClass = _ref.customImageClass,
    fallBackImage = _ref.fallBackImage,
    isListingsView = _ref.isListingsView;
  var classes = useStyles();
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    index = _React$useState2[0],
    setIndex = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isHovered = _React$useState4[0],
    setIsHovered = _React$useState4[1];
  var hasImages = imageLinks.length > 0;
  if (!hasImages && !showImageAsLoading) {
    return /*#__PURE__*/_jsx("div", {
      "data-testid": "generic-placeholder",
      style: {
        position: "relative",
        width: "100%",
        height: "100%"
      },
      children: /*#__PURE__*/_jsx("img", {
        className: classNames(classes.imageClass, customImageClass),
        src: fallBackImage || "https://via.placeholder.com/150"
      })
    });
  }
  var onMouseEnter = function onMouseEnter() {
    setIsHovered(true);
  };
  var onMouseLeave = function onMouseLeave() {
    setIsHovered(false);
  };
  var onPreviousClick = function onPreviousClick(index) {
    var prevIdx = index - 1;
    var shouldCycleToFront = prevIdx < 0;
    if (shouldCycleToFront) {
      setIndex(imageLinks.length - 1);
    } else {
      setIndex(index - 1);
    }
    if (isListingsView) {
      trackEvent(TrackingEventNames.ELEMENT_PRESSED, {
        pageView: TrackingEventPageView.CLIENT_DEALROOM_LISTINGS,
        context: TrackingEventContext.CAROUSEL_ARROWS
      });
    }
  };
  var onNextClick = function onNextClick(index) {
    var nextIdx = index + 1;
    var shouldCycleToBack = nextIdx > imageLinks.length - 1;
    if (shouldCycleToBack) {
      setIndex(0);
    } else {
      setIndex(index + 1);
    }
    if (isListingsView) {
      trackEvent(TrackingEventNames.ELEMENT_PRESSED, {
        pageView: TrackingEventPageView.CLIENT_DEALROOM_LISTINGS,
        context: TrackingEventContext.CAROUSEL_ARROWS
      });
    }
  };
  var isOneImage = imageLinks.length === 1;
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(_defineProperty(_defineProperty(_defineProperty({}, classes.loadingImage, showImageAsLoading), classes.carouselContainerHideHover, !isHovered), classes.carouselContainer, isHovered)),
    style: {
      position: "relative",
      width: "100%",
      height: "100%",
      justifyContent: "center",
      display: "flex"
    },
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    "data-testid": "carousel",
    children: [isOneImage ? null : /*#__PURE__*/_jsxs("div", {
      className: classes.chevronContainer,
      children: [/*#__PURE__*/_jsx("div", {
        "data-testid": "left-chevron",
        style: {
          position: "absolute",
          left: -4,
          width: 60,
          height: 45,
          pointerEvents: "auto"
        },
        onClick: function onClick(e) {
          e.stopPropagation();
          onPreviousClick(index);
        },
        children: /*#__PURE__*/_jsxs("span", {
          className: classNames("fa-stack fa-2x", classes.chevron),
          style: {
            position: "absolute",
            left: 4,
            top: 8
          },
          children: [/*#__PURE__*/_jsx("i", {
            className: "fas fa-circle fa-stack-2x"
          }), /*#__PURE__*/_jsx("i", {
            className: "fal fa-angle-left fa-stack-1x fa-inverse"
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        "data-testid": "right-chevron",
        style: {
          position: "absolute",
          right: -4,
          width: 60,
          height: 45,
          pointerEvents: "auto"
        },
        onClick: function onClick(e) {
          e.stopPropagation();
          onNextClick(index);
        },
        children: /*#__PURE__*/_jsxs("span", {
          className: classNames("fa-stack fa-2x", classes.chevron),
          style: {
            position: "absolute",
            right: 4,
            top: 8
          },
          children: [/*#__PURE__*/_jsx("i", {
            className: "fas fa-circle fa-stack-2x"
          }), /*#__PURE__*/_jsx("i", {
            className: "fal fa-angle-right fa-stack-1x fa-inverse"
          })]
        })
      })]
    }), /*#__PURE__*/_jsx("img", {
      "data-testid": "carousel-image",
      className: classNames(classes.imageClass, customImageClass),
      src: imageLinks[index],
      onClick: onImageClick
    })]
  });
};